import {BookmarkHelpers} from "../helpers/bookmark-helpers";

/**
 * Handles the Portal Bookmarks widget.
 *
 * Each card rendered by the widget has a `.bookmark-remove-trigger` button.
 * Clicking it removes the bookmark via the API and pulls the card out of the DOM.
 * If no cards remain we replace the list with the standard empty-state message.
 */
export class PortalBookmarks {
	private readonly container: HTMLElement;

	constructor(container: HTMLElement) {
		this.container = container;
		this.initRemoveTriggers();
	}

	private initRemoveTriggers(): void {
		const triggers = this.container.querySelectorAll<HTMLElement>('.bookmark-remove-trigger');
		triggers.forEach(trigger => {
			trigger.addEventListener('click', (e) => this.handleRemove(e, trigger));
		});
	}

	private handleRemove(e: Event, trigger: HTMLElement): void {
		e.preventDefault();

		const identifier = trigger.dataset.identifier;
		if (!identifier) return;

		const card = trigger.closest('.portal-resource-item') as HTMLElement | null;

		fetch(`/api/bookmarks/remove?fileIdentifier=${encodeURIComponent(identifier)}`, {
			credentials: 'same-origin'
		}).then(response => {
			if (!response.ok) return;

			BookmarkHelpers.removeFromCache(identifier);

			if (card) {
				card.remove();
			}

			this.checkEmptyState();
		});
	}

	private checkEmptyState(): void {
		const remaining = this.container.querySelectorAll('.portal-resource-item').length;
		if (remaining === 0) {
			this.container.innerHTML = '<p>You have no bookmarks yet.</p>';
		}
	}
}

